import { DashboardProps } from "./types/dashboardProps.d";
import DashboardWidgetBillingSpecialistAlerts from "./widgets/billingSpecialist/alerts.widget";
import DashboardWidgetBillingSpecialistDistricts from "./widgets/billingSpecialist/districts.widget";
import DashboardWidgetBillingSpecialistGeneral from "./widgets/billingSpecialist/general.widget";
import DashboardWidgetBillingSpecialistNotifications from "./widgets/billingSpecialist/notifications.widget";
import DashboardWidgetBillingSpecialistReports from "./widgets/billingSpecialist/reports.widget";
import DashboardWidgetBillingSpecialistTherapists from "./widgets/billingSpecialist/therapists.widget";
import DashboardWidgetHeaderNotification from "./widgets/header-notification.widget";
import DashboardWidgetTemplate from "./widgets/tbd.widget";

const BillingSpecialistDashboard = ({ discipline, user }: DashboardProps): JSX.Element => {
  return (
    <div className="dashboard directorDashboard">
      <div className="w-full">
        <DashboardWidgetHeaderNotification discipline={discipline} user={user} />
      </div>
      <div className="grid grid-cols-3">
        <div className="grid grid-cols-1">
          <DashboardWidgetBillingSpecialistDistricts discipline={discipline} user={user} />
          <DashboardWidgetBillingSpecialistTherapists discipline={discipline} user={user} />
        </div>
        <DashboardWidgetBillingSpecialistNotifications discipline={discipline} user={user} />
        <DashboardWidgetBillingSpecialistAlerts discipline={discipline} user={user} />
        <DashboardWidgetBillingSpecialistGeneral discipline={discipline} user={user} />
        <DashboardWidgetTemplate discipline={discipline} user={user} />
        <DashboardWidgetBillingSpecialistReports discipline={discipline} user={user} />
      </div>
    </div>
  );
};

export default BillingSpecialistDashboard;
